import React, { useState, useRef, useEffect } from "react";

export default function ResizablePanel({
  direction = "horizontal", // 'horizontal' or 'vertical'
  initialSize = 268,
  minSize = 180,
  maxSize = 500,
  panelContent,
  children,
  className = "",
  isShowSidebar = false,
}) {
  const [size, setSize] = useState(initialSize);
  const isResizing = useRef(false);

  const startResizing = () => (isResizing.current = true);
  const stopResizing = () => (isResizing.current = false);

  const resize = (e) => {
    if (!isResizing.current) return;

    if (direction === "horizontal") {
      const newWidth = Math.min(Math.max(e.clientX, minSize), maxSize);
      setSize(newWidth);
    } else {
      const newHeight = Math.min(Math.max(e.clientY, minSize), maxSize);
      setSize(newHeight);
    }
  };

  useEffect(() => {
    window.addEventListener("mousemove", resize);
    window.addEventListener("mouseup", stopResizing);
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [direction]);

  // Styles depend on direction
  const panelStyle =
    direction === "horizontal"
      ? { gridTemplateColumns: `${size}px 1fr` }
      : { gridTemplateRows: `${size}px 1fr` };

  return (
    <div
      className={`relative  overflow-hidden w-full flex-1 ${className} ${
        isShowSidebar && "md:grid"
      }`}
      style={panelStyle}
    >
      {/* Panel */}
      <div
        className={` flex flex-col  ${
          isShowSidebar
            ? "h-[calc(100vh-50px)] md:relative absolute top-0 left-0 z-[2]"
            : "34px absolute top-0 left-0 z-[2]"
        }`}
        style={{
          [direction === "horizontal" ? "width" : "height"]: size,
          transition: isResizing.current ? "none" : "all 0.2s ease",
        }}
      >
        {panelContent}

        {/* Resize Handle */}
        {isShowSidebar && !(minSize === maxSize) && (
          <div
            onMouseDown={startResizing}
            className={`absolute bg-white ${
              direction === "horizontal"
                ? "top-1/2 -translate-y-1/2 right-0 h-full  cursor-col-resize flex items-center flex-col justify-center  border-x px-0.5 border-[#C9C9C9]"
                : "bottom-0 left-1/2 -translate-x-1/2  w-full border-y py-0.5 border-[#C9C9C9] mx-auto cursor-row-resize"
            } `}
          >
            <div
              className={` mx-auto rounded-full bg-black/30 hover:bg-[#50546a] transition-colors ${
                direction === "horizontal" ? "h-[56px] w-1" : "w-[56px] h-1"
              }`}
            ></div>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="h-[calc(100vh-50px)] flex flex-col overflow-hidden ">
        {children}
      </div>
    </div>
  );
}
